<template>
        <div
          v-if="a.requiredCardsBlock5.length"
          class="required-block required-block-5"
        >
          <h6 class="required-block-title mb-1">
            المجموعة الخامسة
          </h6>
          <div class="d-flex flex-wrap required-block-cards">
                <attachment-media-card
                  v-for="card in a.requiredCardsBlock5"
                  :key="`required-${card.key}`"
                  :title="card.key"
                  :file="card.file"
                  :upload-value="a.requiredUploads[card.key]"
                  upload-layout="stacked"
                  :show-team-disabled-message="a.isUploadDisabledByTeam(card.key)"
                  :upload-disabled="a.isUploadDisabledByTeam(card.key)"
                  :uploading="a.isUploadingRequired(card.key)"
                  :is-cad-ark="card.key === 'ملف CAD من الارك'"
                  card-margin-class=""
                  notes-section-class=""
                  notes-textarea-class=""
                  :show-collection-checkbox="a.isProject168 && Boolean(card.file)"
                  :collection-selected="Boolean(card.file && a.isCollectionSelected(card.file))"
                  :editing-note="a.isFileNoteEditing(card.file)"
                  :note-draft="a.getFileNoteDraft(card.file)"
                  :saving-note="a.isFileNoteSaving(card.file)"
                  @update:upload-value="a.setRequiredUpload(card.key, $event)"
                  @submit-upload="a.submitRequired(card.key)"
                  @delete="a.deleteFile(card.file.id)"
                  @save-note="a.saveNote(card.file)"
                  @cancel-edit-note="a.cancelEditingNote(card.file.id)"
                  @start-edit-note="a.startEditingNote(card.file)"
                  @update:note-draft="a.setFileNoteDraft(card.file, $event)"
                  @collection-change="a.onCollectionCheckboxChange(card.file, $event)"
                />

          </div>
        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsBlock5',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
